import styled, { css } from 'styled-components/macro';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as X } from '../../assets/icons/x.svg';
import { transactionFilter, ButtonFilter } from '../TableFilterStyles';

export const CalendarFilterDiv = styled.div`
  ${transactionFilter};
  ${ButtonFilter};
  flex-grow: unset;
  width: 250px;
  justify-content: flex-start;
  ${props =>
    props.isActive &&
    css`
      justify-content: space-evenly;
    `}
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}

  @media screen and (max-width: 767px) {
    ${props =>
      !props.rightEnd &&
      !props.open &&
      !props.isActive &&
      css`
        &::after {
          display: none;
        }
      `}
  }
  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `}
`;

export const XWrapperDiv = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CalendarSvg = styled(Calendar)`
  width: 16px;

  fill: ${props => props.theme.black};

  ${props =>
    props.disabled &&
    css`
      fill: ${props => props.theme.dustyGray};
    `}
  ${props =>
    props.isActive &&
    css`
      fill: ${props => props.theme.black};
    `}
`;

export const CalendarP = styled.p`
  margin-left: 12px;
  z-index: 1;
  color: ${props => props.theme.black};

  ${props =>
    props.disabled &&
    css`
      color: ${props => props.theme.dustyGray};
    `}
`;

// DisplayCalendar
export const DisplayCalendarWrapperDiv = styled.div`
  position: absolute;
  right: 0;
  > .DateRangePicker {
    position: unset;
    > div {
      > .DateRangePickerInput {
         border-bottom: none;
         > .DateRangePickerInput_arrow {
           display: none;
         }
         > .DateRangePickerInput_clearDates {
           display: none;
         }
        > .DateInput {
          position: unset;
          /* display: none; */
> input {
  display: none;
}
        }
      }
      > .DateRangePicker_picker {
        top: 4rem !important;
        left: auto !important;
        right: 0 !important;
        @media screen and (max-width:320px) {
          left: auto !important;
          right: auto !important;
          transform: translateX(-93%);
        }
        @media screen and (min-width: 768px) and (max-width: 1023px) {
          right: -85px !important;
        }
        .CalendarDay__selected {
          background: ${props => props.theme.mercury};
          border: 1px double ${props => props.theme.brand};
        }
      }
    }
    .datepicker-container {
      display: flex;
      justify-content: center;
      align-items: center;
      .caret {
        color: black;
      }
      .datepicker-options {
        display: none;
        .visible {
          display: flex;
        }
      }
      .datepicker-header {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .datepicker-date-filter {
        display: none;
      }
      .datepicker-date-filter-active {
        display: flex;
      }
    }

    .DateInput_fang {
      z-index: 10;
      top: 56px !important;
    }

    .DateRangePicker_picker {
      z-index: 2;
    }

    .DateRangePickerInput__withBorder {
      border: transparent;
      /* border-bottom: 1px solid ${props => props.theme.brand}; */
      background-color: transparent;
    }

    .DateInput {
      background-color: transparent;
    }

    .DateInput_1 {
      /* border: 2px solid red; */
      width: 90px;
    }

    .DateRangePickerInput_arrow_svg {
      height: 17px;
      width: 17px;
    }

    .DateInput_input {
      font-size: 12px;
      background-color: transparent;
      color: ${props => props.theme.brand};
    }

    .DateInput_input__focused {
      border-bottom: 2px solid ${props => props.theme.brand};
    }

    .CalendarMonth_caption {
      font-size: 1.4rem;
      letter-spacing: 0.04rem;
       ${props => props.theme.fontStackHeader};
      text-transform: uppercase;
      line-height: 1.8rem;
    }

    /* .DayPicker_weekHeader { */
    /* top: 52px; */
    /* } */

    .calendar-preset-container {
      background-color: ${props => props.theme.brand};
      /* text-align: left; */
      /* padding-left: 20px; */
    }
    .calendar-preset-btn {
      background-color: ${props => props.theme.brand};
      color: white;
      height: 50px;
      text-transform: uppercase;
      font-weight: 600;
      cursor: pointer;
    }

    /* Will edit everything selected including everything between a range of dates */
    .CalendarDay__selected_span {
      background: ${props => props.theme.concrete};
      color: black;
      /* border: 1px solid ${props => props.theme.concrete}; */
      border: none;
    }

    /* Will edit selected date or the endpoints of a range of dates */
    .CalendarDay__selected {
      background: ${props => props.theme.concrete};
      color: black;
      border: 2px solid ${props => props.theme.brand};
    }

    /* Will edit when hovered over. _span style also has this property */
    .CalendarDay__selected:hover {
      background: ${props => props.theme.concrete};
      color: black;
      border: 2px solid ${props => props.theme.brand};
    }

    .CalendarDay__selected_span:hover {
      background: ${props => props.theme.concrete};
      color: black;
      border: 2px solid ${props => props.theme.brand};
    }

    /* Will edit when the second date (end date) in a range of dates */
    /* is not yet selected. Edits the dates between your mouse and said date */
    .CalendarDay__hovered_span:hover,
    .CalendarDay__hovered_span {
      background: ${props => props.theme.concrete};
      background-color: ${props => props.theme.concrete};
      color: black;
      border: 1px solid ${props => props.theme.concrete};
    }

    .DateRangePickerInput__showClearDates {
      /* border: 2px solid red; */
      padding-right: 16px;
    }

    .DateRangePickerInput_clearDates {
      padding: 0px;
      margin: 0 10px 0 5px;
    }

    td.CalendarDay {
      padding-top: 1rem;
    }

    @media screen and (min-width: 768px) {
      .calendar-preset-container {
        padding-left: 20px;
      }
      .datepicker-container {
        display: inline-flex;
        order: 1;
        width: 225px;
      }
      .DateInput_input {
        padding: 0 10px;
        margin-bottom: -1px;
        font-size: 1.3rem;
      }
      .DateRangePickerInput {
        border-bottom: 1px solid ${props => props.theme.dustyGray};
      }
    }
  }
`;

export const CalendarPresetsContainerDiv = styled.div`
  background-color: ${props => props.theme.brand};
  display: flex;
  justify-content: space-evenly;
  @media screen and (min-width: 768px) {
    .calendar-preset-container {
      padding-left: 20px;
    }
  }
`;

export const XSvg = styled(X)`
  width: 9px;
  height: 9px;
  fill: ${props => props.theme.black};
  cursor: pointer;
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
  z-index: 1;
`;

export const CalendarClosedP = styled.p`
  color: ${props => props.theme.blue};
  margin-left: 12px;
  z-index: 1;
`;
